var JSZip = require("jszip");

class ProcessUnZipper {
    // TODO WRITE CHECKS TO VALIDATE FILE TO UNZIP
    // SHOULD ONLY ALLOW FOR APR FILES FROM RECORDER

    async unZip(zipFile) {
        if (!zipFile) {
            console.error("There is no file to be unziped!");
            return null;
        }

        const fileNameArray = zipFile.name.split(".")
        const fileType = fileNameArray[fileNameArray.length - 1];
        if (fileType !== 'apr') {
            return null;
        }

        const rawFiles = await this._getZipEntries(zipFile).then(this._decodeEntryData);

        return rawFiles.map(rawFile => {
            return {
                name: rawFile.name,
                type: rawFile.data.type,
                data: rawFile.data.data
            }
        })
    }

    // TODO SPLIT UP METHOD: HOW TO DO THIS WHILE INSIDE PROMISE?
    async _decodeEntryData(zipEntries) {
        const entries = zipEntries.map(entry => {
            const entryWithData = entry
                .async('base64')
                .then(function (content) {

                    // TODO GIVE CREDITS TO https://stackoverflow.com/a/30106551
                    function b64DecodeUnicode(str) {
                        return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
                            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                        }).join(''))
                    }

                    // TODO IMPLEMENT SUPPORT FOR JPG? SOLVE IF INVALID INPUT EG __MACOSX/.
                    const fileEnding = entry.name.split('.').slice(-1).pop()
                    let entryData = null
                    switch (fileEnding) {
                        case 'json':
                            entryData = {
                                type: 'json',
                                data: JSON.parse(b64DecodeUnicode(content))
                            }
                            break;
                        case 'png':
                            entryData = {
                                type: 'png',
                                // TODO IS THERE A BETTER WAY THAN 'HARDCODING' TYPE THIS WAY?
                                data: 'data:image/png;base64,'.concat(content)
                            }
                            break;
                        default:
                            throw 'ERROR unsupported filtype: ' + fileEnding;
                    }

                    entry.data = entryData
                    return entry

                }, function error(e) {
                    console.log('ERROR in decodeEntries: ' + e);
                });
            return entryWithData
        })
        const decodedEntries = await Promise.all(entries);
        return decodedEntries;
    }

    async _getZipEntries(f) {
        return await JSZip.loadAsync(f)
            .then(function (zip) {

                const zipEntries = []

                zip.forEach(function (relativePath, zipEntry) {
                    zipEntries.push(zipEntry)
                });

                return zipEntries;

            },
                function error(e) {
                    console.log('ERROR in getZipEntries: ' + e);
                });
    }
}

export { ProcessUnZipper }
